$(document).ready(function () {

  const giftHandles = [
      'bearbeitungsgebuhr'
  ];

  console.log("giftHandles: ",giftHandles);

  // Normalize pathname and remove trailing slash if present
  const path = window.location.pathname.toLowerCase().replace(/\/$/, '');
  const parts = path.split('/').filter(Boolean);
  
  if (parts.length >= 2 && parts[0] === 'products') {
      const currentHandle = parts[1];

      // If handle matches a restricted gift product → redirect
      if (giftHandles.includes(currentHandle)) {
      window.location.replace('/'); // redirect to homepage
      }
  }

  $(".confirm").click(function () {
    $(".sweet-alert").fadeOut();
  });

  $(document).on("click","#cart-drawer-live-region-checkout.disabled",function() {
      event.preventDefault();
      event.stopPropagation();
      var variantMetafieldsLength = $(".variant_metafields").length;
      var title = $(".variant_metafields").data("title");
      var qty = $(".variant_metafields").data('minqty');
      $(".popupMinItemQty").text(qty);
      $(".popupPoductTitle").text(title);
      console.log(variantMetafieldsLength);
      if (variantMetafieldsLength > 0) {
        var type = $(".variant_metafields").data("type");
        $(".pop-text").hide();
        $(type).show();
        $(".sweet-alert").show();
    
      }
    });

  
  $(".confirm_update").click(function(){

        var lineItemId = $(".variant_metafields").data("id");
        var minQty = $(".variant_metafields").data('minqty');


        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {

                var currentQuantity = 0;
                for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].id == lineItemId) {
                        currentQuantity = cart.items[i].quantity;
                        break;
                    }
                }

                var newQuantity = currentQuantity + minQty - (currentQuantity % minQty);
                if (newQuantity <= currentQuantity) {
                    newQuantity += minQty;
                }

                var data = {
                    updates: {}
                };
                data.updates[lineItemId] = newQuantity;

                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: data,
                    dataType: 'json',
                    success: function(response) {
                        console.log("Cart updated successfully:", response);
                        location.reload();
                    },
                    error: function(xhr, status, error) {
                        console.error("Error updating cart:", error);
                    }
                });
            },
            error: function(xhr, status, error) {
                console.error("Error fetching cart details:", error);
            }
        });
    });

  $(document).on("change","[data-option-value]",function() {
    var id = $('[name="id"]').val();
    $('.hide-var-data').hide();
    $(`.p_var_min-${id}`).show();
  });

});


$(document).on("click","#cart-sidebar-live-region-checkout",function(e) {
      $(".popup-content").empty('');
      if ($(this).hasClass('disabled')) {
          e.preventDefault(); 
          console.log("Element is disabled");
          $('body').addClass('modal-open');
     }

      var data_product_qty = $(this).attr("data-product-qty");
      var data_product_title = $(this).attr("data-product-title");
  
      // var content = $('.alert--content').text().trim();
      if($(this).hasClass('sales-disable')){
        var message = "Die Anzahl für "+ data_product_title+" wird auf ganze Verkaufseinheiten ("+data_product_qty+") aufgerundet."
      }else if($(this).hasClass('min-disable')){
        var message = "Für den Artikel " + data_product_title + " gilt eine Mindestbestellmenge von " + data_product_qty +" Stück.";
      }
      $(".popup-content").append(`<h2 class='beachten-title'>Bitte Mengen beachten!</h2><p>${message}</p>`);
});

$(document).on("click",".close-popup",function(e) {
  $('body').removeClass('modal-open');
});